import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { slugify, unslugify } from '../utils/slugify';
import SEO from '../components/SEO';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.sofiasurgicals.com';

function Instruments() {
  const { categoryName } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!categoryName) return;

    const controller = new AbortController();

    const fetchData = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(`${BASE_URL}/api/all-instupment`, {
          signal: controller.signal,
        });

        const all = res.data?.data || [];
        const decoded = unslugify(categoryName);

        const filtered = all.filter(
          (item) =>
            unslugify(item.categoryName?.categoryName)?.toLowerCase() ===
            decoded.toLowerCase()
        );
        setData(filtered);
      } catch (err) {
        if (err.name !== 'CanceledError' && err.name !== 'AbortError') {
          setError('Failed to load instruments. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => controller.abort();
  }, [categoryName]);

  const displayCategory = unslugify(categoryName || 'Instruments');

  return (
    <>
      <SEO
        title={`${displayCategory} Surgical Instruments`}
        description={`Explore high-precision ${displayCategory} surgical instruments manufactured by Sofia Surgicals India. ISO and CE certified.`}
        keywords={`${displayCategory}, surgical instruments, orthopaedic instruments India, surgery tools`}
        url={`/Instruments/${categoryName}`}
      />
      {/* Hero section */}
      <section className="implants">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="ourproduct">
                <h2 className="product">
                  Instruments
                  {displayCategory && (
                    <span className="category-subtitle"> — {displayCategory}</span>
                  )}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Loading */}
      {loading && (
        <section className="implants">
          <div className="container">
            <div className="row mt-1 py-4 implants-card">
              {[1, 2, 3, 4].map((n) => (
                <div className="col-md-3" key={n}>
                  <div className="category-card skeleton-card">
                    <div className="skeleton-img" />
                    <div className="skeleton-title" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Error */}
      {!loading && error && (
        <p className="text-center text-danger mt-5 mb-5 fs-5">{error}</p>
      )}

      {/* Data */}
      {!loading && !error && data.length > 0 && (
        <section className="implants">
          <div className="container">
            <div className="row mt-1 py-4 implants-card">
              {data.map((instrument) => {
                const slug = slugify(instrument.instupmentName || '');
                const imgSrc = instrument.instupmentImage
                  ? `${BASE_URL}/${instrument.instupmentImage}`
                  : '/placeholder.jpg';

                return (
                  <div className="col-md-3 col-sm-6 mb-4" key={instrument._id || slug}>
                    <div className="category-card">
                      <Link to={`/instrument-details/${slug}`}>
                        <img
                          src={imgSrc}
                          alt={instrument.instupmentName}
                          className="img-fluid"
                          width={250}
                          height={230}
                          loading="lazy"
                          onError={(e) => { e.target.src = '/placeholder.jpg'; }}
                        />
                      </Link>
                      <div className="category-title">
                        {instrument.instupmentName}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* Empty state */}
      {!loading && !error && data.length === 0 && (
        <p className="text-uppercase mb-5 mt-5 text-center fs-2">
          No Instruments found for this category.
        </p>
      )}
    </>
  );
}

export default Instruments;